import type { FC } from "react";

import { Checkout } from "app/components/React/TableSelectionComponents/segment-selection/segments-modal/Checkout";
import type { SegmentsModalProps } from "app/components/React/TableSelectionComponents/segment-selection/segments-modal/types";

import { Wizard } from "./Wizard";

export const STEPS_COMPONENTS: Record<string, FC<SegmentsModalProps>> = {
    Wizard,
    Checkout,
};

export type Step = keyof typeof STEPS_COMPONENTS;
